import { render, staticRenderFns } from "./InterestingList.vue?vue&type=template&id=40cc467d"
import script from "./InterestingList.vue?vue&type=script&lang=js"
export * from "./InterestingList.vue?vue&type=script&lang=js"
import style0 from "./InterestingList.vue?vue&type=style&index=0&id=40cc467d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports